import React, { useEffect } from 'react';
import {
	Route,
	BrowserRouter as Router,
	Routes,
	useLocation,
} from 'react-router-dom';
import Header from './components/Header';
import PrivateRoute from './components/privateRoute';
import AdminRoute from './components/adminRoute';
import SalesForm from './sections/Form';
import AdminPanel from './sections/pageSections/Admin/AdminPanel';
import Orders from './sections/pageSections/Orders';
import Profile from './sections/pageSections/Profile';
import Review from './sections/pageSections/Review';
import SetPasswordForm from './sections/subsections/SetPasswordForm';
import LoginForm from './sections/subsections/loginForm';

import { AuthProvider, useAuth } from './contexts/AuthContext';
import { setupAxiosInterceptors } from './utils/axiosConfig';
import { useTokenRefresh } from './hooks/useTokenRefresh';
import MailServerWarning from './components/MailServerWarning';
import ClientVersionNotice from './components/ClientVersionNotice';

import './assets/scss/main.scss';

const AppContent = () => {
	const location = useLocation();
	const { logout, refreshToken, devMailMode } = useAuth();

	// Setup axios interceptors on mount
	useEffect(() => {
		setupAxiosInterceptors(logout, refreshToken);
	}, [logout, refreshToken]);

	// Enable automatic token refresh based on user activity
	useTokenRefresh();

	const showHeader = !location.pathname.startsWith('/admin');

	return (
		<div className={`App ${devMailMode ? 'dev-mail-mode' : ''}`}>
			<ClientVersionNotice />
			<MailServerWarning />
			{showHeader && (
				<header className='App-header'>
					<Header />
				</header>
			)}
			<div className={showHeader ? 'mainContent' : 'adminContent'}>
				<Routes>
					<Route path='/' element={<PrivateRoute><SalesForm /></PrivateRoute>}/>
					<Route path='/login' element={<LoginForm />} />
					<Route path='/set-password' element={<SetPasswordForm />} />
					<Route path='/admin/*' element={<AdminRoute><AdminPanel /></AdminRoute>}/>
					<Route path='/review' element={<PrivateRoute><Review /></PrivateRoute>}/>
					<Route path='/orders' element={<PrivateRoute><Orders /></PrivateRoute>}/>
					<Route path='/profile' element={<PrivateRoute><Profile /></PrivateRoute>}/>
					<Route path='/form/recover/:id' element={<PrivateRoute><SalesForm /></PrivateRoute>} />
				</Routes>
			</div>
		</div>
	);
};

function App() {
	return (
		<AuthProvider>
			<Router>
				<AppContent />
			</Router>
		</AuthProvider>
	);
}

export default App;
